/* eslint import/newline-after-import: "off" */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React,
{
  useState,
  useMemo,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Common/Dialog';
// import DatePicker, { registerLocale } from 'react-datepicker';
import DateFnsUtils from '@date-io/date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import twLocale from 'date-fns/locale/zh-TW'; // the locale you want
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import { formatDate, isWorkingDay, holidays } from 'tools/date';
import {
  DatePicker,
  KeyboardDatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import Styles from './index.module.css';
// registerLocale('zh-TW', twLocale); // register it with the name you want

export default function EndDateModal({
  ad,
  onSubmit,
  onCancel,
}) {
  const localeMap = {
    tw: twLocale,
  };
  const [locale, setLocale] = useState('tw');
  const [workingAd, setWorkingAd] = useState(ad);
  // eslint-disable-next-line no-unused-vars
  const [startDate] = useState(ad.startDate);
  const [endDate] = useState(ad.endDate);
  const [selectedDate, handleDateChange] = useState(new Date());

  const dateSelector = useMemo(() => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <input
        style={{
          all: 'unset',
          margin: '0px 15px',
          color: '#455780',
          fontSize: 19,
        }}
        type="date"
        min={formatDate(workingAd.earliestStartingDate)}
        value={formatDate(workingAd.startDate)}
        onChange={(e) => {
          const newAd = workingAd.clone();
          newAd.startDate = new Date(e.target.value);
          setWorkingAd(newAd);
        }}
      />
      <div className={classNames(Styles.shield)} />
    </div>
  ), [workingAd]);

  useEffect(() => {
    if (workingAd.endDate && workingAd.startDate > workingAd.endDate) {
      const newAd = workingAd.clone();
      newAd.endDate = newAd.startDate;
      setWorkingAd(newAd);
    }
  }, [workingAd]);

  return (
    <Dialog
      open
      title="修改結束日期"
      content={(
        // <div>
        //   {/* {dateSelector} */}
        //   <DatePicker
        //     peekNextMonth
        //     showMonthDropdown
        //     showYearDropdown
        //     dropdownMode="select"
        //     dateFormat="yyyy/MM/dd"
        //     minDate={new Date(formatDate(workingAd.earliestStartingDate))}
        //     selected={new Date(formatDate(workingAd.startDate))}
        //     locale={twLocale}
        //     onChange={(e) => {
        //       const newAd = workingAd.clone();
        //       newAd.startDate = new Date(e);
        //       setWorkingAd(newAd);
        //     }}
        //     open={false}
        //   />
        //   <DatePicker
        //     peekNextMonth
        //     showMonthDropdown
        //     showYearDropdown
        //     dropdownMode="select"
        //     dateFormat="yyyy/MM/dd"
        //     minDate={new Date(formatDate(workingAd.earliestStartingDate))}
        //     selected={new Date(formatDate(workingAd.startDate))}
        //     locale={twLocale}
        //     // withPortal
        //     inline
        //     disabledKeyboardNavigation
        //     onChange={(e) => {
        //       const newAd = workingAd.clone();
        //       newAd.startDate = new Date(e);
        //       setWorkingAd(newAd);
        //     }}
        //   />
        // </div>
        <div>
          <div>
            <span style={{ color: 'red' }}>
              僅能調整結束日
            </span>
            <span>
              ，若需重設廣告走期，
              <br />
            </span>
            <span>
              請點選單元中的「調整廣告開始日」
              <br />
            </span>
            <span>
              <br />
            </span>
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
            <div className={classNames(Styles.picker)}>
              <DatePicker
                autoOk
                disabled
                inputVariant="outlined"
                label="開始日期"
                okLabel="確認上稿"
                cancelLabel="取消"
                format="yyyy/MM/dd"
                // shouldDisableDate={isWorkingDay}
                invalidDateMessage="無效的日期格式"
                value={workingAd.startDate}
                onChange={(e) => {
                  // setStartDate(e);
                  const newAd = workingAd.clone();
                  if (e) {
                    if (e !== newAd.startDate) {
                      const sDate = new Date(formatDate(e));
                      const eDate = (newAd.endDate ? new Date(formatDate(newAd.endDate)) : null);
                      if (newAd.endDate && sDate > eDate) {
                        alert('廣告走期開始日期不能大於結束日期');
                      } else {
                        newAd.startDate = new Date(formatDate(e));
                      }
                    }
                  } else {
                    newAd.startDate = null;
                  }
                  setWorkingAd(newAd);
                }}
              />
            </div>
            {/* <br />
            <br /> */}
            <div className={classNames(Styles.picker)}>
              <DatePicker
                clearable
                inputVariant="outlined"
                label="結束日期(選填)"
                okLabel="確認"
                cancelLabel="取消"
                clearLabel="清除"
                format="yyyy/MM/dd"
                // shouldDisableDate={isWorkingDay}
                minDate={workingAd.earliestEndDate}
                minDateMessage="日期必須大於最小日期"
                invalidDateMessage="無效的日期格式"
                value={workingAd.endDate}
                emptyLabel="請選擇結束日"
                onChange={(e) => {
                  // setEndDate(e);
                  const newAd = workingAd.clone();
                  if (e) {
                    if (e !== newAd.endDate) {
                      const sDate = (newAd.startDate ? new Date(formatDate(newAd.startDate)) : null);
                      const eDate = new Date(formatDate(e));
                      if (newAd.startDate && sDate > eDate) {
                        alert('廣告走期結束日期不能小於開始日期');
                      } else {
                        newAd.endDate = new Date(formatDate(e));
                      }
                    }
                  } else {
                    newAd.endDate = null;
                  }
                  setWorkingAd(newAd);
                }}
              />
            </div>
          </MuiPickersUtilsProvider>
        </div>
      )}
      onSubmit={() => onSubmit(workingAd)}
      onClose={onCancel}
      onCancel={onCancel}
      hideCancel={false}
      submitText="確認上稿"
    />
  );
}

EndDateModal.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

EndDateModal.defaultProps = {
  ad: new Ad(),
  onSubmit: () => { },
  onCancel: () => { },
};
